import * as types from '@store/types'
import axios from 'axios'

const actions = {
  [types.FETCH_ADDRESS_BY_CEP]: async ({ dispatch }, cep) => {
    try {
      const response = await axios.get(`https://brasilapi.com.br/api/cep/v2/${cep}`)
      return response.data
    } catch (err) {
      dispatch(types.FEEDBACK, {
        type: 'error',
        title: 'Erro ao buscar endereço',
        text: 'Verifique se o CEP está correto ou tente novamente mais tarde.'
      })

      return null
    }
  }
}

export default { actions }



// WEBPACK FOOTER //
// ./src/store/modules/payment.js